export const FEEDBACK_TYPES = [
  { value: "academics", label: "Academics", needs: ["course"] },
  { value: "faculty", label: "Faculty / Teaching", needs: ["faculty", "course"] },
  { value: "facility", label: "Facilities", needs: ["facility"] },
  { value: "transport", label: "Transport", needs: ["transport"] },
  { value: "admin", label: "Administration", needs: [] },
  { value: "portal", label: "Portal / IT", needs: ["portal_module"] },
  { value: "safety", label: "Safety / Ragging / Harassment", needs: [] },
  { value: "general", label: "General", needs: [] },
];

export const CATEGORIES = {
  academics: ["Timetable", "Assessment", "Curriculum", "Labs for course", "Exams"],
  faculty: ["Teaching Quality", "Punctuality", "Mentoring", "Doubts Support"],
  facility: ["Classrooms", "Labs", "Library", "Hostel", "Washrooms", "Canteen", "Water", "Power"],
  transport: ["Bus Timings", "Bus Condition", "Driver Behaviour", "Route"],
  admin: ["Certificates", "Fees Counter", "Scholarship", "Office Response"],
  portal: ["Login", "Fees", "Attendance", "LMS", "Marks", "Time-Off", "Other Bug"],
  safety: ["Ragging", "Harassment", "Threat", "Unsafe Area", "Other"],
  general: ["Suggestion", "Complaint", "Appreciation"],
};

export const PORTAL_MODULES = [
  "Fees", "Attendance", "Hostel", "Transport", "LMS", "Marks", "Time-Off", "Admissions"
];
